(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() { this.header = document.querySelector('.header-wrapper'); this.onScrollHandler = this.onScroll.bind(this); window.addEventListener('scroll', this.onScrollHandler); }
    disconnectedCallback() { window.removeEventListener('scroll', this.onScrollHandler); }
    onScroll() { if (window.pageYOffset > 50) { this.header.classList.add('shopify-section-header-sticky'); } else { this.header.classList.remove('shopify-section-header-sticky'); } }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
